<template>
  <div class="content none-click">
    <div class="page">
      <div class="case">
        <div class="title">
          <div class="title-left">
            <div class="text">{{ detail.title }}</div>
          </div>
        </div>
        <div class="bottom">{{ detail.createTime }}</div>
      </div>
      <div class="rich-text" v-html="detail.content" />

      <div class="case">
        <div class="title">
          <div class="title-left">
            <img src="@/assets/Mobile/images/icon/icon-newsCenter-latestNews.png">
            <div class="text">最新动态</div>
          </div>
        </div>
      </div>
      <div class="dataList">
        <div v-for="(item, index) in dataList" :key="index" class="">
          <div class="item flexbox-row" @click="linkTo(item.id)">
            <div class="item-content">
              <div class="title">
                {{ item.title }}
              </div>
              <div v-if="item.introduction" class="content">
                {{ item.introduction }}
              </div>
              <div class="bottom">
                {{ item.createTime }}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import Case from '@/Mobile/Mobilecom/Case'

import { getNewsList } from '@/apis/index.js'
import { getNewsDetail } from '@/apis/news.js'
import moment from 'moment'

export default {
  metaInfo: metaInfo.Finance,
  components: {
    ContactForm,
    Case
  },
  data() {
    return {

      // 新闻数据
      dataList: [],

      id: this.$route.query.id,
      detail: {
        content: ''
      }
    }
  },
  watch: {
    $route() {
      this.id = this.$route.query.id
    },
    id() {
      this.getDetail()
    }
  },
  mounted() {
    this.getDetail()
    this.getNewsList()
  },
  methods: {
    // 跳转详情
    linkTo(id) {
      this.$router.push({ path: 'newsDetail', query: { id }})
      this.id = this.$route.query.id
    },
    // 查询详情
    getDetail() {
      const { id } = this
      getNewsDetail({ id }).then(res => {
        res.createTime = moment(res.createTime).format('YYYY-MM-DD')
        this.detail = res
      })
    },

    // 获取新闻数据
    async getNewsList() {
      await getNewsList({ page: 1, rows: 6, type: 1 }).then(res => {
        res.forEach(v => {
          v.createTime = moment(v.createTime).format('YYYY-MM-DD')
        })
        this.dataList = this.dataList.concat(res)
      }).catch(e => {
      })
    }

  }
}
</script>

<style lang="less" scoped>
.rich-text{
  padding: 20px 15px;
      ::v-deep {
        p {
          margin-bottom: 20px;
          font-size: 16px;
          line-height: 27px;
          text-indent: 32px !important;

          img {
            margin-left: -32px;
          }
        }
        span {
          font-size: 17px !important;
          line-height: 26px !important;
          letter-spacing: 0.8px;
        }

        img{
          width: 100% !important;
          height: auto !important;
          border-radius: 4px;
        }
      }
}
.page{
  padding-top: 0.8rem;
  margin-top: 20px;
  text-align: left;
}
.dataList{
  padding: 0 10px 40px;

  .item{
    display: flex;
    flex-direction: row;
    height: 100%;
    padding: 12px 0;
    border-top: 1px solid rgb(238 238 238 / 50%);
    .image{
      width: 120px;
      height: 60px;
      img{
        width: 100%;
        height: 100%;
      }
    }

    .item-content{
      width: 100%;
      margin:0 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title{
        font-size: 14px;
        line-height: 18px;
      }
      .content{
        margin-top: 8px;
        font-size: 11px;
        line-height: 12px;
        color: #a0a0a0;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
      .bottom{
        margin-top: 8px;
        text-align: left;
        font-size: 11px;
        line-height: 12px;
        color: #a0a0a0;

      }
    }
  }
}
.case{
  padding: 0 19px;
  text-align: left;
  .title{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 17px 0;
    .title-left{
      display: flex;
      flex-direction: row;
      align-items: center;
        img{
          width: 25px;
          height: 25px;
          margin-right: 5px;
        }
       .text{
         font-size: 18px;
         font-weight: bold;
         word-break: break-all;
      }
    }

  }
  .bottom{
    font-size: 11px;
    line-height: 12px;
    color: #a0a0a0;
  }
  .content{
    .item{
      padding-bottom: 5px;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
  }
}
.seeMore{
  text-align: center;
}

</style>
